import { createBlockNameGenerator } from '@aspectus/bem'

const blockName = createBlockNameGenerator()

export default {
  props: {
    cfg: {
      type: [String, Array],
    },
    fw: String,
    lh: String,
    fs: {
      type: [String, Array],
    },
    align: String,
    color: {
      type: String,
    },
    download: String,
    disabled: Boolean,
    tag: String,
  },
  computed: {
    genetatedClass() {
      return blockName(this.block, {
        cfg: this.cfg,
        fw: this.fw,
        lh: this.lh,
        fs: this.fs,
        align: this.align,
        color: this.color,
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/js/components/Controls/bemto/mixins/BemtoMixin.js